import { FormFieldProps, FormFieldData } from './type'
import { FormFieldType } from './type'
import { Input } from '@/components/ui/input'
import { Badge } from '@/components/ui/badge'
import { X } from 'lucide-react'
import { useState, useEffect } from 'react'

export const FormHashtagField = ({
  data,
  field,
}: FormFieldProps<FormFieldData>) => {
  const [inputValue, setInputValue] = useState('')
  const [hashtags, setHashtags] = useState<string[]>(() => {
    // field.value가 있으면 hashtag 속성을 추출, 없으면 빈 배열
    if (field.value && Array.isArray(field.value)) {
      return field.value.map((v) => v.hashtag || v).filter(Boolean)
    }
    return data.default || []
  })
  const [isComposing, setIsComposing] = useState(false)

  useEffect(() => {
    field.onChange(hashtags)
  }, [hashtags, field])

  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault()
      if (!isComposing) {
        addHashtag()
      }
    }
  }

  const addHashtag = () => {
    const trimmedValue = inputValue.trim()
    if (trimmedValue && !hashtags.includes(trimmedValue)) {
      const newHashtags = [...hashtags, trimmedValue]
      setHashtags(newHashtags)
      setInputValue('')
    }
  }

  const removeHashtag = (tagToRemove: string) => {
    const newHashtags = hashtags.filter((tag) => tag !== tagToRemove)
    setHashtags(newHashtags)
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value)
  }

  const handleCompositionStart = () => {
    setIsComposing(true)
  }

  const handleCompositionEnd = () => {
    setIsComposing(false)
  }

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-2">
        {hashtags.map((tag, index) => (
          <Badge
            key={index}
            variant="secondary"
            className="flex items-center gap-1 px-2 py-1"
          >
            #{tag}
            <button
              type="button"
              onClick={() => removeHashtag(tag)}
              className="ml-1 rounded-full p-0.5 hover:bg-gray-200"
            >
              <X size={12} />
            </button>
          </Badge>
        ))}
      </div>
      <Input
        type="text"
        placeholder="해시태그를 입력하고 Enter 또는 쉼표를 누르세요"
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={handleInputKeyDown}
        onCompositionStart={handleCompositionStart}
        onCompositionEnd={handleCompositionEnd}
        className="w-full"
      />
    </div>
  )
}
